import { BalanceData } from "@highmarch/domain";

/**
 * What's new on the hub (hub redesign follow-up): towers the player hasn't looked at yet (the Towers tab's NEW badge).
 * Live events and their More dot moved to the event calendar (balance events.json, features/events.ts; WP6). Pure, so
 * the rules are testable without a DOM.
 */

/** Ids of the owned tower types (not the base). */
export function ownedTowerIds(B: BalanceData, owned: readonly boolean[]): string[] {
  return B.towers.filter((t) => !t.isBase && owned[t.index]).map((t) => t.id);
}

/**
 * Owned towers the player hasn't seen on the Towers page. `seen` undefined means a save from before the badge: the
 * caller records everything owned as seen first, so this returns nothing rather than calling every tower new.
 */
export function unseenTowers(B: BalanceData, owned: readonly boolean[], seen: readonly string[] | undefined): string[] {
  if (!seen) return [];
  const s = new Set(seen);
  return ownedTowerIds(B, owned).filter((id) => !s.has(id));
}
